import React, { useMemo } from 'react'
import s from './Route.less'
import RouteLabelComponents from './RouteLabelComponents'
import classnames from 'classnames'
import { useSelector } from 'react-redux'
import { selectProviders } from '../../store/itinerary/itinerary.selectors'
import { useAction } from '../utils/react-redux'
import { navigateToProvider } from '../../store/itinerary/itinerary.actions'
import useEventCallback from '../utils/useEventCallback'
import { useScrollContext } from '../genericComponents/ResponsiveScrollableWrapper/ResponsiveScrollableWrapper'
import T from '../i18n/T'
import { LabelComponentBuilder } from '../../store/itinerary/routes.utils'

const buildTitleComponents = ({ icon, label }) => {
  return [LabelComponentBuilder.picto(icon), LabelComponentBuilder.text(label)]
}

const RouteOptional = ({ route }) => {
  const providers = useSelector(selectProviders)
  const provider = useMemo(() => providers.find((p) => p.name === route.provider), [route, providers])
  const execNavigateToProvider = useAction(navigateToProvider)
  const { scrollTop } = useScrollContext()

  const onClick = useEventCallback(() => {
    execNavigateToProvider({ mode: provider.mode, provider: provider.name })
    scrollTop()
  }, [provider])

  return (
    <li className={classnames(s.route, s.routeOptional)} onClick={onClick}>
      <div className={s.routeTitle}>
        <RouteLabelComponents components={buildTitleComponents(provider)} />
      </div>
      <div className={s.showRoute}>
        <T id={'itinerary.see-route'} />
      </div>
    </li>
  )
}

export default RouteOptional
